// add target blank to external links
const siteUrl = window.location.hostname;
let links = document.querySelectorAll('a[href*="//"]:not([href*="' + siteUrl + '"])');
for (let elem of links) {
  elem.setAttribute('target', '_blank');
  elem.setAttribute('rel',  'noopener noreferrer');
}